module.exports = __webpack_public_path__ + "media/images/lp_consultation/ic-arrow-down-blue-8dc5e8cfa918fecf0db547f7f2dcfe94.svg";